// ShipListItem.tsx
import React, { useState } from 'react';
import {
  AccordionContent,
  AccordionListItem,
  Separator,
  TruncatedText,
} from '@ais-ui/ui-core';
import { cn } from '@ais-ui/utils';
import { v4 as uuidv4 } from 'uuid';
import { DetailedShipList, ShipList } from '@ais-ui/api-spec/config';
import { DeleteShiplist } from '../Mutations/filter/DeleteShiplist';
import { EditShiplist } from '../Mutations/shiplist/EditShiplist';
import { ShipListItemContent } from './ShipListItemContent';
import { ShipListTable } from './ShipListTable';
import {
  ApplyShiplistAsFilterButton,
  ApplyShiplistAsColorButton,
} from './ShipListActionButtons';
import { ShipListDropdownMenu } from './ShipListDropdownMenu';

interface ShipListItemProps {
  shiplist: ShipList;
}

export const ShipListItem = ({ shiplist }: ShipListItemProps) => {
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showShips, setShowShips] = useState(false);
  const [detailedShiplist, setDetailedShiplist] = useState<
    DetailedShipList | undefined
  >();

  const onShowShips = (detailedShipList: DetailedShipList) => {
    setShowShips(true);
    setDetailedShiplist(detailedShipList);
  };

  const onDelete = () => {
    setShowDeleteDialog(true);
  };

  const onEdit = () => {
    setShowEditDialog(true);
  };

  return (
    <AccordionListItem
      key={shiplist.id}
      value={shiplist.id ? shiplist.id : uuidv4()}
      className="pr-2"
      actionButtons={
        <>
          <ApplyShiplistAsFilterButton shiplist={shiplist} />
          <ApplyShiplistAsColorButton shiplist={shiplist} />
          <Separator orientation="vertical" className="h-6 bg-border" />
        </>
      }
      triggerContent={
        <div className="w-full">
          <TruncatedText
            text={shiplist.name || ''}
            className="text-sm text-left font-medium leading-none group-hover:underline"
            maxWidth="180px"
          />
        </div>
      }
      kebabMenu={
        <ShipListDropdownMenu
          shiplist={shiplist}
          onShowShips={onShowShips}
          onDelete={onDelete}
          onEdit={onEdit}
        />
      }
    >
      {showShips && detailedShiplist && (
        <ShipListTable
          detailedShiplist={detailedShiplist}
          showPopover={showShips}
          setShowPopover={setShowShips}
        />
      )}

      <AccordionContent>
        <ShipListItemContent shiplist={shiplist} />
      </AccordionContent>

      {showDeleteDialog && (
        <DeleteShiplist
          shiplist={shiplist}
          showDialog={showDeleteDialog}
          setShowDialog={setShowDeleteDialog}
        />
      )}

      {showEditDialog && (
        <EditShiplist
          showDialog={showEditDialog}
          setShowDialog={setShowEditDialog}
          shiplist={shiplist}
        />
      )}
    </AccordionListItem>
  );
};
